import React, { useEffect } from 'react';
import TspLayout from './TspLayout';
import { NavigatingAway, useNavigation } from './TspNavigation';
import Sidebar from '../Sidebar/Sidebar';
import TspMap from '../Map';
import { useTsp } from '../context/TspContext';

/**
 * Main TSP page component
 * Uses Context to get state
 */
export default function TspPage() {
  // Get required state from context
  const { 
    showPanel,
    setShowPanel
  } = useTsp();
  
  // Use navigation service
  const { goToHome, isMountedRef, isNavigatingRef } = useNavigation();
  
  // Component mount/unmount handling + Memory Management
  useEffect(() => {
    isMountedRef.current = true;
    isNavigatingRef.current = false;
    
    return () => {
      isMountedRef.current = false;
    };
  }, [isMountedRef, isNavigatingRef]);

  // Check if navigating away
  if (isNavigatingRef.current) {
    return <NavigatingAway />;
  }

  // Sidebar component - now using Context internally
  const sidebarComponent = <Sidebar />;

  // Map component - now using Context internally
  const mapComponent = <TspMap />;

  return (
    <TspLayout
      showPanel={showPanel}
      setShowPanel={setShowPanel}
      goToHome={goToHome}
      sidebar={sidebarComponent}
      map={mapComponent}
    />
  );
} 